export default "__VITE_ASSET__DwhoxEG9__"